module.exports = __webpack_public_path__ + "static/media/receipe-min.583fca93.png";